import resume from '../assets/pdf/resume.pdf'
import photo from '../assets/png/photo.png';

export const headerData = {
    name: 'Oleh Kimak',
    title: "Senior Full Stack Engineer",
    desciption:"There wasn't a bird in the sky, but that was not what caught his attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. He knew what was coming and he hoped he was prepared.",
    image: photo,
    resumePdf: resume
}
//https://imageupload.io/ib/jWlIApnUl70Ad6S_1698718488.png